var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigFingerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 8.75H14.7792L15.949 5.24271C16.1594 4.60938 16.0531 3.90729 15.6625 3.36563C15.2719 2.82396 14.6385 2.5 13.9708 2.5H12.2917C11.9823 2.5 11.6896 2.6375 11.4906 2.875L6.59479 8.75H3.95833C2.80938 8.75 1.875 9.68438 1.875 10.8333V20.2083C1.875 21.3573 2.80938 22.2917 3.95833 22.2917H17.8198C18.2436 22.2903 18.6571 22.1603 19.0054 21.9188C19.3538 21.6774 19.6207 21.3359 19.7708 20.9396L22.6427 13.2823C22.6863 13.1653 22.7085 13.0415 22.7083 12.9167V10.8333C22.7083 9.68438 21.774 8.75 20.625 8.75ZM3.95833 10.8333H6.04167V20.2083H3.95833V10.8333ZM20.625 12.7281L17.8198 20.2083H8.125V10.1688L12.7792 4.58333H13.9729L12.3458 9.46146C12.293 9.61804 12.2783 9.78495 12.3029 9.94836C12.3274 10.1118 12.3906 10.267 12.4871 10.4011C12.5837 10.5352 12.7108 10.6444 12.858 10.7195C13.0051 10.7947 13.1681 10.8337 13.3333 10.8333H20.625V12.7281Z",
    fill: "white",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFingerIcon);
export default __webpack_public_path__ + "static/media/big-finger-icon.0f4163539264cb0ff11935b37b9a4f1c.svg";
export { ForwardRef as ReactComponent };